import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { getDashboardPath } from '../../config/roleConfig';
import type { UserRole } from '../../types';

export const DashboardRedirect: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const hasNavigated = useRef(false);

  useEffect(() => {
    // Prevent multiple navigations
    if (hasNavigated.current) {
      return;
    }

    if (!user) {
      // User not logged in, redirect to login
      hasNavigated.current = true;
      navigate('/auth/login', { replace: true });
      return;
    }

    // Get user's primary role
    const userRole = user.roles?.[0];

    if (!userRole) {
      // No role assigned, this shouldn't happen but redirect to login
      hasNavigated.current = true;
      navigate('/auth/login', { replace: true });
      return;
    }

    // Get dashboard path for user's role
    const dashboardPath = getDashboardPath(userRole as UserRole);

    // Redirect to appropriate dashboard
    hasNavigated.current = true;
    navigate(dashboardPath, { replace: true });
  }, [user, navigate]);

  // Show loading state while determining which dashboard to show
  return (
    <div className="flex h-screen items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="mb-4 flex justify-center">
          <div className="h-12 w-12 animate-spin rounded-full border-4 border-gray-300 border-t-primary-600" />
        </div>
        <p className="text-gray-600">Loading your dashboard...</p>
      </div>
    </div>
  );
};
